import React from 'react'

const Notes = () => {
  return (
    <div>Notes</div>
  )
}

export default Notes